<template>
  <v-flex class="profiles">
    <v-layout align-center>
      <h1>Admins</h1>
      <v-spacer />

      <v-dialog v-model="newAdminDialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn color="success" dark v-on="on">
            New Admin <v-icon right>add</v-icon>
          </v-btn>
        </template>
        <new-admin
          v-if="newAdminDialog"
          @close="newAdminDialog = !newAdminDialog"
        />
      </v-dialog>
    </v-layout>
    <v-card>
      <v-list v-if="loaded" two-line class="mt-3 pt-0 pb-0">
        <template v-for="(admin, index) in admins">
          <v-list-item :key="admin.id">
            <v-list-item-avatar>
              <v-icon color="primary" class="mr-2">person</v-icon>
            </v-list-item-avatar>
            <v-list-item-content> {{ admin.email }} </v-list-item-content>

            <v-list-item-action>
              <v-tooltip left color="error">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="ml-2 mr-0"
                    v-on="on"
                    @click="openRevokeDialog(admin)"
                  >
                    <v-icon color="error">remove_circle</v-icon>
                  </v-btn>
                </template>
                <span>Revoke admin</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index + 1 < admins.length" :key="index"></v-divider>
        </template>
      </v-list>
      <v-alert
        v-if="admins.length === 0 && loaded"
        :value="true"
        type="info"
        color="primary"
        outlined
      >
        There are no admins to display
      </v-alert>
    </v-card>

    <v-progress-linear
      v-if="!loaded"
      color="info"
      :indeterminate="true"
      class="mt-3"
    />
    <v-dialog v-model="revokeDialog" persistent max-width="290">
      <v-card>
        <v-app-bar flat dark color="primary">
          <v-toolbar-title>Are you sure?</v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          Are you should you would like to remove this user's admin rights?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="revokeDialog = false">Cancel</v-btn>
          <v-btn
            color="error"
            :loading="loadingRevoke"
            @click="revokeAdmin(currentAdmin)"
            >Revoke</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import { adminsCollection, FieldValue } from '../firebaseConfig.js';
import NewAdmin from '@/components/NewAdmin';

export default {
  name: 'Admins',
  components: {
    NewAdmin
  },
  data() {
    return {
      loaded: false,
      admins: [],
      revokeDialog: false,
      newAdminDialog: false,
      currentAdmin: null,
      loadingRevoke: false
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    }
  },
  mounted() {
    this.getAdmins();
  },
  methods: {
    openRevokeDialog(admin) {
      this.currentAdmin = admin;
      this.revokeDialog = true;
    },
    revokeAdmin() {
      this.loadingRevoke = true;
      adminsCollection
        .doc(this.currentAdmin.id)
        .update({ locations: FieldValue.arrayRemove(this.currentLocationId) })
        .then(() => {
          this.revokeDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'success',
            text: `Admin removed successfully`
          });
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error removing admin: ${error}`
          });
        })
        .finally(() => {
          this.loadingRevoke = false;
        });
    },
    getAdmins() {
      this.$bind(
        'admins',
        adminsCollection.where(
          'locations',
          'array-contains',
          this.currentLocationId
        )
      )
        .then(() => {
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading admins: ${error}`
          });
        });
    }
  }
};
</script>
